import { RequestService } from "../../../../../common/services/RequestService";
import { adjustMonetizationTemplateData } from "./adjustOfferData";
import { CREATE_MONETIZATION_TEMPLATE } from "../../../../../common/api/constants";

export const createMonetizationTemplateRequest = async (profileId, data) => {
  const response = await RequestService.post(CREATE_MONETIZATION_TEMPLATE, {
    ...adjustMonetizationTemplateData(data),
    profile_id: profileId
  });
  return response && response.data;
};
